export default __webpack_public_path__ + "static/media/email-yellow.56503706.svg";